import { auth } from '@webclient/lib/agent';

import { AuthResponseType, LoginBodyType } from '@webclient/shared-types/auth';

import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

type Params = {
  onSuccess?: (
    data: AxiosResponse<AuthResponseType, any>,
    variables: LoginBodyType,
    context: unknown,
  ) => Promise<unknown> | unknown;
  onError?: (
    error: Error,
    variables: LoginBodyType,
    context: unknown,
  ) => Promise<unknown> | unknown;
};

const login = async (data: LoginBodyType) => await auth.login(data); // TODO: check if this is needed at all

export default function useLogin({ onError, onSuccess }: Params) {
  return useMutation({
    mutationFn: login,
    onSuccess,
    onError,
  });
}
